import React from "react";
import {Route, Routes} from "react-router-dom";
import BoardManagerList from "../container/boardManager/BoardManagerList";
import CreateBoardManager from "../container/boardManager/CreateBoardManager";
import UpdateBoardManager from "../container/boardManager/UpdateBoardManager";

const BoardManager = () => {
  return (
    <Routes>
      <Route path="/*" element={<BoardManagerList />} />
      <Route path="Create" element={<CreateBoardManager />} />
      <Route path="Edit/:id" element={<UpdateBoardManager />} />
    </Routes>
  );
};

export default BoardManager;
